module.exports = __webpack_public_path__ + "img/brand-vuejs.9a45fc76.svg";